import React, { FC } from "react";
import cn from "classnames";
import "./ChartTooltipMultiline.styles.scss";
import { iTooltipRow } from "./ChartTooltipMultiline.helpers";

const ChartTooltipMultiline: FC<{
    title: string;
    rows: iTooltipRow[];
    columns: string[];
    x: number;
    y: number;
    position: 'top' | 'bottom';
    align: 'left' | 'center' | 'right';
    columnSeparatorIndex?: number;
    hasHeader: boolean;
}> = (
    {
        title,
        rows,
        columns,
        x,
        y,
        position,
        align,
        hasHeader,
        columnSeparatorIndex,
    }
) => {
    return (
        <div
            className="FoodSummaryChartTooltipMultiline"
            style={{
                transform: `translate(${x}px, ${y}px)`,
            }}
        >
            <div className={cn(
                "FoodSummaryChartTooltipMultiline__arrow",
                `p-${position}`,
                `a-${align}`,
            )}/>
            <div className={cn(
                "FoodSummaryChartTooltipMultiline__inner",
                `p-${position}`,
                `a-${align}`,
            )}>
                {hasHeader && (
                    <div className="FoodSummaryChartTooltipMultiline__header">
                        {columnSeparatorIndex !== undefined && (
                            <div className="FoodSummaryChartTooltipMultiline__row height-s">
                                <div className="FoodSummaryChartTooltipMultiline__cell"/>
                                {columns.slice(0, columnSeparatorIndex + 1).map(columnTitle => (
                                    <div
                                        key={columnTitle}
                                        className="FoodSummaryChartTooltipMultiline__cell"
                                    />
                                ))}
                                <div className={cn(
                                    "FoodSummaryChartTooltipMultiline__cell font-small",
                                    `span-${columns.slice(columnSeparatorIndex + 1).length}`,
                                )}>
                                    Predicted
                                </div>
                            </div>
                        )}
                        <div className="FoodSummaryChartTooltipMultiline__row">
                            <div className="FoodSummaryChartTooltipMultiline__cell">
                                {title}
                            </div>
                            {columns.map((columnTitle, columnIndex) => (
                                <>
                                    <div key={columnTitle} className="FoodSummaryChartTooltipMultiline__cell">
                                        {columnTitle}
                                    </div>
                                    {columnIndex === columnSeparatorIndex && (
                                        <div className="FoodSummaryChartTooltipMultiline__separator"/>
                                    )}
                                </>
                            ))}
                        </div>
                    </div>
                )}
                <div className="FoodSummaryChartTooltipMultiline__body">
                    {rows.map((row, rowIndex) => (
                        <div
                            key={`${row.title} ${row.values.join(' | ')} ${row.isActive ? 'active' : ''}`}
                            className={cn("FoodSummaryChartTooltipMultiline__row", row.isActive && 'is-active')}
                        >
                            <div className="FoodSummaryChartTooltipMultiline__cell">
                                {row.title}
                            </div>
                            {columns.map((_, columnIndex) => (
                                <>
                                    <div
                                        key={row.values[columnIndex]}
                                        className="FoodSummaryChartTooltipMultiline__cell"
                                    >
                                        {row.values[columnIndex] || '-'}
                                    </div>
                                    {columnIndex === columnSeparatorIndex && (
                                        <div className="FoodSummaryChartTooltipMultiline__separator"/>
                                    )}
                                </>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChartTooltipMultiline;
